import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import ExportIcon from "@/components/icons/exportIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportButton',
  props: {
    title: {
        type: String,
        default: "Export"
    }
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit

const action = () => {
    emit("click");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonComponent, {
    customClass: "quaternary",
    onClick: action
  }, {
    default: _withCtx(() => [
      _createVNode(ExportIcon, { class: "object-contain w-4 h-4 mr-1 -ml-2 icon" }),
      _createElementVNode("span", null, _toDisplayString(__props.title), 1)
    ]),
    _: 1
  }))
}
}

})